@if (answersCount > 0) {
<div class="answers-info" (click)="onThreadClick($event)">
  <span class="answers-amount">{{ answersCount }} Antworten</span>
  <span class="last-answer-time">Letzte Antwort {{ lastTime }}</span>
</div>
}
